<mat-card *ngIf="inMaintenanceMode">
    <mat-card-content>
        <div class="container">
            <mat-icon>info</mat-icon>
            <span>Maintenance Mode is enabled</span>
        </div>
    </mat-card-content>
</mat-card>